import type { SearchTaskRequest } from '@askporter/client-grieg-lyric';
import { pathKey } from './path';

/** Params for POST `tasks/search`. */
export type TasksSearchKeyParams = SearchTaskRequest;

export type TasksSearchStatsKeyParams = {
  postData: TasksSearchKeyParams;
  isForFetchingAllStats: true;
};

export type TasksSearchPostKeyParams = {
  postData: TasksSearchKeyParams;
};

/** Task domain query segments */
export const TasksQueryKeys = {
  search: {
    all: ['tasks/search'] as const,
    list: (params: TasksSearchKeyParams) => ['tasks/search', params] as const,
    stats: (params: TasksSearchStatsKeyParams) => ['tasks/search', params] as const,
    post: (params: TasksSearchPostKeyParams) => ['tasks/search', params] as const,
    linkedList: (searchParams: unknown) => ['tasks/search', 'linked-tasks-list', searchParams] as const,
  },
  filterValues: {
    all: ['task-filter-values'] as const,
  },
  filters: {
    all: ['task-filters'] as const,
  },
  types: {
    all: ['task-types'] as const,
    detail: (uid: string) => ['task-types', uid] as const,
    flatAll: ['task-types-flat'] as const,
    transformedAll: ['task-types-transformed'] as const,
    pathAll: () => pathKey('task-types'),
    pathDetail: (uid: string) => pathKey(`task-types/${uid}`),
  },
  detail: (uid: string) => pathKey(`tasks/${uid}`),
  /** String-segment task detail used in communication chip */
  detailSegment: (uid: string) => ['tasks', uid] as const,
  messages: {
    searchAll: ['task-messages/search'] as const,
    search: (payload: unknown) => ['task-messages/search', payload] as const,
  },
  extensions: {
    appointment: (taskUid: string, activityUid: string) =>
      [`task-extensions/appointment/${taskUid}/${activityUid}`] as const,
    workOrder: (taskUid: string, activityUid: string) =>
      [`task-extensions/work-order/${taskUid}/${activityUid}`] as const,
    quotes: (taskUid: string, activityUid: string) => [`task-extensions/quotes/${taskUid}/${activityUid}`] as const,
    quotePathDetail: (extensionPath: string, quoteUid: string) => pathKey(`${extensionPath}/${quoteUid}`),
    preApproval: (taskUid: string, activityUid: string) =>
      pathKey(`task-extensions/pre-approval/${taskUid}/${activityUid}`),
  },
  quotes: {
    ssuSearch: ['users/search', 'SSU_SEARCH'] as const,
    serviceUserSearch: ['users/search', 'SERVICE_USER_SEARCH'] as const,
  },
  emails: {
    detail: (emailUid: string) => pathKey(`emails/${emailUid}`),
  },
  assetDetail: (assetUid: string) => ['asset-detail', assetUid] as const,
};
